import React from 'react';

export default function Dev() {
  return <div style={{ width: '1000px' }}>devvvv</div>;
}
